import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const style = {
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'    
  },
  refresh: {
    display: 'inline-block',
    position: 'relative',
  },
};

const LoadingIndication = () => (
  <div className='loading-indication-container' style={style.container}>
    <CircularProgress
      size={50}
      left={0}
      top={50}
      status="loading"
      style={style.refresh}
    />
  </div>
);

export default LoadingIndication;